import React from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, logout } from "../firebase";
import { useNavigate } from "react-router-dom";
import { clearLocalStorage } from "utils/storage";

function Logout(props) {
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();
  if (user) {
    clearLocalStorage();
    logout();
  }

  return <div>Logging Out...</div>;
}

export default Logout;
